import React, { useState, useEffect } from 'react';
import AlertModal from "../AlertModal";

const SkipReasonModal = ({ isOpen, onClose, exercise, testId, onSubmit }) => {
    const [selectedAnswerId, setSelectedAnswerId] = useState(null);
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        if (isOpen && exercise && exercise.SkipWhyQuestions && exercise.SkipWhyQuestions.length > 0) {
            const initialAnswerId = exercise.SkipWhyQuestions[0].AnswerId;
            if (initialAnswerId) {
                setSelectedAnswerId(initialAnswerId);
            } else {
                setSelectedAnswerId(null);
            }
        }
    }, [isOpen, exercise]);

    if (!isOpen || !exercise) return null;

    const skipQuestions = exercise.SkipWhyQuestions || [];
    if (skipQuestions.length === 0) return null;

    const question = skipQuestions[0]; // Display the first question
    const responses = question?.Responses || [];

    const handleSelect = (answerId) => {
        setSelectedAnswerId(answerId);
        setShowError(false);
    };

    const handleSubmit = () => {
        if (!selectedAnswerId) {
            setShowError(true);
            return;
        }

        const answer = {
            QuestionId: question.QuestionId,
            AnswerId: selectedAnswerId,
            AnswerList: []
        };

        onSubmit(answer);
    };

    const handleClose = () => {
        setSelectedAnswerId(null);
        setShowError(false);
        onClose();
    };

    return (
        <AlertModal
            show={isOpen}
            confirmBtnText="Submit"
            cancelBtnText="Cancel"
            showConfirm={true}
            showCancel={true}
            showCloseButton={true}
            onConfirm={handleSubmit}
            onCancel={handleClose}
            onClose={handleClose}
            closeOnClickOutside={false}
        >
            <div className="movement-core__skip-reason-modal">
                <div className="movement-core__skip-reason-modal-title">
                    {question.QuestionTitle || `Why would you skip this (${exercise.ExerciseDisplayName}) movement?`}
                </div>

                {!!exercise?.SkipReasonPromptTitle && (
                    <div className="movement-core__skip-reason-modal-subtitle">
                        {exercise.SkipReasonPromptTitle}
                    </div>
                )}

                <div className="movement-core__skip-reason-modal-options">
                    {responses.map((response, idx) => {
                        const isSelected = selectedAnswerId === response.AnswerId;
                        return (
                            <button
                                key={response.AnswerId || idx}
                                className={`movement-core__skip-reason-modal-option-btn ${isSelected ? "selected-option" : ""}`}
                                onClick={() => handleSelect(response.AnswerId)}
                                type="button"
                            >
                                {response.AnswerTitle}
                            </button>
                        );
                    })}
                </div>

                {showError && (
                    <div className="movement-core__skip-reason-modal-error">
                        Please select a reason to continue.
                    </div>
                )}
            </div>
        </AlertModal>
    );
};

export default SkipReasonModal;
